import { FC, Fragment } from 'react';

import { Checkbox, Divider, Typography } from '@cfa/react-components';

export type Label = Record<
  string,
  { translationString: string; value: boolean }
>;

type FilterCheckboxSectionOnChangeHandler = (key: string) => void;

export interface FilterCheckboxSectionProps {
  // Can be a single group, or groups separated by divider
  labels: Label | Label[];
  noMargin?: boolean;
  onChange?: FilterCheckboxSectionOnChangeHandler;
  onToggle?: (value: string) => void;
  title: string;
}

const FilterCheckboxSection: FC<FilterCheckboxSectionProps> = ({
  labels,
  noMargin = false,
  onChange,
  title,
  onToggle,
}) => {
  const labelGroups = Array.isArray(labels) ? labels : [labels];

  const handleChange = (key: string) => {
    if (onChange) {
      onChange(key);
    } else if (onToggle) {
      onToggle(key);
    }
  };

  return (
    <div
      data-testid={'CheckboxFilterSection'}
      className="static m-0 w-full self-start overflow-y-auto text-left"
    >
      <Typography className="mb-2.5" fontWeight="bold" variant="body1">
        {title}
      </Typography>
      {!noMargin && <div className="my-4" />}
      <div className="ml-1 flex flex-col gap-2">
        {labelGroups.flatMap((labels, i) => (
          <Fragment key={`checkbox-group-${i}`}>
            {Object.entries(labels).map(([key, val]) => (
              <Checkbox
                key={key + 'checkbox-filter-section'}
                checked={val.value}
                label={val.translationString}
                onChange={() => {
                  handleChange(key);
                }}
              />
            ))}
            {labelGroups.length > 1 && i < labelGroups.length - 1 && (
              <Divider className="my-2!" variant="fullLength" />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default FilterCheckboxSection;
